import axios from 'axios';
import firebase from 'firebase/app';
import 'firebase/auth';

const headers = async () => {
  return { 'X-MJN-CREW-FIR': await firebase.auth().currentUser.getIdToken() };
};

export const requester = async () =>
  axios.create({
    baseURL: `${process.env.VUE_APP_API_BASE_URL}/api/v1/employee`,
    headers: await headers()
  });
